import React, {useEffect} from 'react';
import styled, {createGlobalStyle} from 'styled-components';
import AdBlockModal from './AdBlockModal';
import SheetMenu from '../SheetMenu';
import SignupSheetProvider from './Provider';
import SignupDetailsProvider from '../SignupDetails/Provider';
import AllegedEmailProvider from '../AllegedEmail/Provider';
import {ModalProvider} from 'styled-react-modal';
import {FadingBackground} from '../../../lib/ui/v1/Modal';
import {AlertProvider} from '../../../lib/hooks';
import SignupSheetBody from './Body';
import ReactGA from 'react-ga';
import Meta from '../Meta';
import getBugsnagErrorBoundary from '../../../lib/services/getBugsnagErrorBoundary';
import initializeReactGA from '../../../lib/services/getBugsnagErrorBoundary';

const GlobalStyle = createGlobalStyle`
  @media print {
    body {
      background-image: none;
      background-color: transparent;
    }
    #topnav,
    #bottomnav {
      display: none;
    }
  }
`;

// Patch for Samsung Internet (Browser) V 7.2
// see: https://github.com/SamsungInternet/support/issues/56
if (navigator.userAgent.match(/SamsungBrowser\/7\.2/i)) {
  Function.prototype.ToString = function () { return this.toString(); }
}

const MainContainer = styled.section`
  margin-top: 0;
  display: flex;
  flex-direction: row;
  @media (max-width: 800px) {
    flex-direction: column;
  }
  justify-content: space-between;
`;

const UnknownError = () => {
  return (
    <div>
      Oops, there was an unexpected error. An admin has been notified. <strong>Please refresh the page.</strong>
    </div>
  )
}

const SignupSheet = ({signupSheet}) => {
  const isProduction = process.env.NODE_ENV === 'production';
  const {currentUser, sheet: {title}} = signupSheet;
  useEffect(() => {
    document.title = title;
  }, []);
  const {id: userId, email, fullName} = currentUser || {};
  initializeReactGA({ userId });
  const ErrorBoundary = getBugsnagErrorBoundary({ user: currentUser });
  return (
    <ErrorBoundary FallbackComponent={UnknownError}>
      <Meta
        title={title}
      />
      <AlertProvider>
        <SignupSheetProvider signupSheet={signupSheet}>
          <ModalProvider backgroundComponent={FadingBackground}>
            <SignupDetailsProvider>
              <AllegedEmailProvider>
                <GlobalStyle />
                <MainContainer>
                  <SignupSheetBody />
                  <SheetMenu />
                </MainContainer>
              </AllegedEmailProvider>
              <AdBlockModal />
            </SignupDetailsProvider>
          </ModalProvider>
        </SignupSheetProvider>
      </AlertProvider>
    </ErrorBoundary>
  );
}

export default SignupSheet;
